import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EngineerLayout from './EngineerLayout';
import { 
    FaArrowLeft, 
    FaPrint,
    FaCheck
} from 'react-icons/fa';

const EngineerDDRCertificate = () => {
    const navigate = useNavigate();
    const [certificateDate, setCertificateDate] = useState('');
    
    const handlePrint = () => {
        window.print();
    };

    return (
        <EngineerLayout>
            <div className="p-6 md:p-8 bg-gray-50/50 min-h-screen">
                {/* Header Section */}
                <div className="flex justify-between items-center mb-8 px-2 font-marathi no-print">
                    <div className="flex items-center gap-4">
                        <button 
                            onClick={() => navigate(-1)}
                            className="p-2 bg-white rounded-full shadow-sm hover:bg-gray-50 transition text-gray-600 border border-gray-100"
                        >
                            <FaArrowLeft size={16} />
                        </button>
                        <h1 className="text-xl font-bold text-gray-800">DDR Certificate</h1>
                    </div>
                    <div className="text-xs font-medium text-gray-400">
                        Zilla Parishad / <span className="text-gray-500 font-bold uppercase tracking-wider">Certificate</span>
                    </div>
                </div>

                {/* Form Card */}
                <div className="bg-white rounded-xl shadow-md border border-gray-100 p-8 mb-8 no-print">
                    <div className="flex flex-wrap items-end gap-6 justify-between">
                        <div className="space-y-2 w-full max-w-xs">
                            <label className="text-[13px] font-bold text-gray-500 font-marathi">
                                DDR Certificate Date <span className="text-red-500">*</span>
                            </label>
                            <input 
                                type="date"
                                className="w-full border border-gray-100 rounded-lg px-4 py-2 text-sm outline-none focus:border-blue-400 bg-gray-50/50 transition-all font-bold"
                                value={certificateDate}
                                onChange={(e) => setCertificateDate(e.target.value)}
                            />
                        </div>
                        <div className="flex gap-4">
                            <button className="bg-[#6366f1] hover:bg-[#4f46e5] text-white px-8 py-2.5 rounded-lg font-bold shadow-lg shadow-indigo-500/20 transition transform active:scale-95 flex items-center gap-2 uppercase text-xs">
                                Submit
                            </button>
                            <button 
                                onClick={handlePrint}
                                className="bg-[#6366f1] hover:bg-[#4f46e5] text-white px-8 py-2.5 rounded-lg font-bold shadow-lg shadow-indigo-500/20 transition transform active:scale-95 flex items-center gap-2 uppercase text-xs"
                            >
                                <FaPrint /> Print
                            </button>
                        </div>
                    </div>
                </div>

                {/* Certificate Section (Printable) */}
                <div className="bg-white rounded-xl shadow-2xl border border-gray-50 p-[2rem] md:p-[4rem] max-w-5xl mx-auto print-container">
                    {/* Header with Logo */}
                    <div className="text-center mb-2">
                        <div className="flex justify-center mb-4">
                            <img src="/pune_zp_logo.png" alt="Zilla Parishad Logo" className="h-24 w-auto object-contain" onError={(e) => e.target.src = "https://ekamwatapzp.punecorp.in/static/media/zp_logo.c81f7f02.png"} />
                        </div>
                        <h2 className="text-2xl font-bold text-gray-900 font-marathi">पुणे जिल्हा परिषद पुणे</h2>
                        <h3 className="text-xl font-bold text-gray-800 font-marathi">बांधकाम उत्तर विभाग</h3>
                        <p className="text-lg font-bold text-gray-700 font-marathi">यशवंतराव चव्हाण भवन, वेलस्ली रोड, कॅम्प, पुणे - ४११००१.</p>
                        <p className="text-lg font-bold text-gray-700 font-marathi">बांधकाम (उत्तर) विभाग, ४ था मजला</p>
                    </div>

                    <div className="flex justify-between items-center border-b border-gray-300 pb-2 mb-8 font-marathi text-[14px] font-bold">
                        <div>दूरध्वनी क्र.-०२०-२६१३३०१४</div>
                        <div>Email :- worksnorth1@gmail.com</div>
                    </div>

                    <div className="space-y-6 font-marathi text-gray-800">
                        <div className="flex justify-between">
                            <div className="text-lg font-bold underline">विषय-मजूर सहकारी संस्थांचे वर्गीकरण करणे बाबत.</div>
                        </div>

                        <div className="flex justify-between items-start text-sm font-bold">
                            <div className="space-y-1">
                                <p>मा.सादर</p>
                            </div>
                            <div className="text-right">
                                <p>दिनांक- {new Date().toLocaleDateString('en-GB')}</p>
                            </div>
                        </div>

                        <p className="text-[15px] font-bold leading-relaxed indent-12">
                            खालील मजूर सह.संस्था यांनी वर्ग अ अकुशल वर्गा मध्ये वर्गीकरण प्रस्ताव या कार्यालयास सादर केले होते.
                        </p>

                        <div className="overflow-hidden border border-gray-300 rounded-sm">
                            <table className="w-full border-collapse">
                                <thead>
                                    <tr className="bg-gray-100 border-b border-gray-300">
                                        <th className="px-4 py-3 border-r border-gray-300 text-left text-[14px] w-16">अ.क्र.</th>
                                        <th className="px-4 py-3 border-r border-gray-300 text-left text-[14px]">मजूर संस्थेचे नाव</th>
                                        <th className="px-4 py-3 text-left text-[14px] w-40">वर्गीकरण</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="border-b border-gray-300 font-bold text-[14px]">
                                        <td className="px-4 py-4 border-r border-gray-300">1</td>
                                        <td className="px-4 py-4 border-r border-gray-300">साईनाथ मजूर सहकारी संस्था मर्यादित</td>
                                        <td className="px-4 py-4 text-gray-600">अ अकुशल</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <p className="text-[14px] font-bold leading-relaxed text-justify">
                            संबंधीत मजूर सहकारी संस्था यांनी सादर केलेल्या कागदपत्राबाबत मा. जिल्हा उपनिबंधक सहकारी संस्था, पुणे यांचेकडे खातरजमा करण्यासाठी व सदर संस्थेची आर्थिक पात्रता असलेबाबत शिफारशीसाठी प्रस्ताव पाठविला असून सदर प्रस्तावास मा.जिल्हा उपनिबंधक सहकारी संस्था पुणे ग्रामीण यांनी वरील प्रमाणे त्यांच्या कडील पत्र जाक्रं. जिउनिग्रा/ <span className="mx-2">10344 /मजूर/ साईनाथ मजूर सहकारी संस्था मर्यादित / अ अकुशल</span> /प्र.सन २२ /दिनांक 26/02/2026 अन्वये अ वर्ग मध्ये वर्गीकरण करणेस शिफारस केली असून सोबत शिफारसपत्रे अटीलोकनार्थ सोबत सादर केलेली आहेत.
                        </p>

                        <p className="text-[14px] font-bold leading-relaxed text-justify">
                            संबंधीत चेअरमन मजूर सहकारी संस्था यांनी नोंदणी करण्यासाठी आवश्यक ती नोंदणी फी चलनाने भरणा केली असून संबंधीत नस्तीस चलनाची प्रत समाविष्ट करणेत आलेली आहे. शासन निर्णय सार्वजनिक बांधकाम विभाग क्रं.सीएटी 2017/प्र.क्र.103/इमा.2 दिनांक 23.7.18 च्या निर्णयानुसार वर्गीकरण प्रस्ताव मान्यतेस सादर केलेले असून सदरच्या प्रस्तावास मान्यता मिळणेस विनंती आहे.
                        </p>

                        <p className="text-[14px] font-bold leading-relaxed">
                            तरी वरील संस्थांचे वर्गीकरण पत्र तयार केले असून त्यावर स्वाक्षरी होणेस विनंती आहे.
                        </p>

                        {/* Signatures */}
                        <div className="pt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 font-bold text-center">
                            <div className="space-y-16">
                                <div className="h-12 flex justify-center items-end">
                                    <img src="/signature_placeholder.png" alt="" className="h-16 opacity-30 grayscale" onError={(e) => e.target.style.display = 'none'} />
                                </div>
                                <div>
                                    <p className="text-[15px]">क.आरेखन(श्री.शितोळे)</p>
                                </div>
                            </div>
                            
                            <div className="space-y-16">
                                <div className="h-12"></div>
                                <div>
                                    <p className="text-[15px]">स.ले.अ.(श्री.जामदार)</p>
                                </div>
                            </div>

                            <div className="space-y-16">
                                <div className="h-12"></div>
                                <div>
                                    <p className="text-[15px]">मा.का.अ.(श्री. शंकर दराडे)</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
                @media print {
                    .no-print {
                        display: none !important;
                    }
                    body {
                        background: white !important;
                    }
                    .print-container {
                        box-shadow: none !important;
                        border: none !important;
                        padding: 0 !important;
                        margin: 0 !important;
                        max-width: 100% !important;
                    }
                    .App {
                        margin: 0 !important;
                        padding: 0 !important;
                    }
                    @page {
                        margin: 2cm;
                    }
                }
                .font-marathi {
                    font-family: 'Hind', sans-serif;
                }
                @import url('https://fonts.googleapis.com/css2?family=Hind:wght@400;500;600;700&display=swap');
            `}</style>
        </EngineerLayout>
    );
};

export default EngineerDDRCertificate;
